import { useState } from 'react';
import { View, TextInput, StyleSheet, Text, TouchableOpacity } from 'react-native';
import { LockIcon, UserIcon } from '@phosphor-icons/react';
import { Theme } from '../enum/Theme';
import SpaceW from '../comps/SpaceW';
import { navigate } from '../services/NavigationService';
import { EnumRoutesAppWeb } from '../enum/EnumRoutesAppWeb';
import { observer } from 'mobx-react-lite';
import { authStore } from '../stores/AuthStore';
import { userStore } from '../stores/UserStore';
import { blogCategoryStore } from '../stores/BlogCategoryStore';
import { postStore } from '../stores/PostStore';
import { activityStore } from '../stores/ActivityStore';
import { desenvolverStore } from '../stores/DesenvolverStore';
import { extraStore } from '../stores/ExtraStore';
import { shoppingStore } from '../stores/ShoppingStore';
import { version, build} from '../../../../package.json'
import SpaceH from '@comps/SpaceH';
import { bannerStore } from '../stores/BannerStore';

const Auth = observer(() => {
  const [email, setEmail] = useState(__DEV__ ? 'neto@ncast.com.br': '');
  const [password, setPassword] = useState(__DEV__ ? '@Nco972972' : '');
  const { _loading } = authStore; // 🟢 usa o getter correto

  const handleLogin = async () => {
    if (!email || !password) {
      alert('Preencha o e-mail e a senha.');
      return;
    }
    try {
      await authStore.login(email, password);
      if (authStore._isLogged) { // 🟢 usa o getter correto
        navigate(EnumRoutesAppWeb.dashboard);
        await userStore.fetchUsers()
        await blogCategoryStore.fetchCategories()
        await postStore.fetchPosts()
        await activityStore.fetchActivities()
        await extraStore.fetchExtras()
        await desenvolverStore.fetchRanges()
        await bannerStore.fetchBanners()
        await shoppingStore.fetchItens()
      }
    } catch (error: any) {
      console.error(error);
      alert('E-mail ou senha inválidos.');
    }
  };

  return (
    <View style={styles.container}>
      <View style={styles.containerLogin}>
        <Text style={styles.title}>Login</Text>

        <View style={styles.inputContainer}>
          <UserIcon size={24} color={Theme.foreground} />
          <SpaceW />
          <TextInput
            autoComplete="email"
            style={styles.input}
            placeholder="E-mail"
            keyboardType="email-address"
            placeholderTextColor="#fff"
            value={email}
            onChangeText={setEmail}
          />
        </View>

        <View style={styles.inputContainer}>
          <LockIcon size={24} color={Theme.foreground} />
          <SpaceW />
          <TextInput
            autoComplete="password"
            style={styles.input}
            placeholder="Senha"
            secureTextEntry
            placeholderTextColor="#fff"
            value={password}
            onChangeText={setPassword}
          />
        </View>

        <TouchableOpacity
          style={[styles.button, _loading && { opacity: 0.7 }]}
          onPress={handleLogin}
          disabled={_loading}
        >
          <Text style={styles.buttonText}>{_loading ? 'Acessando...' : 'Acessar'}</Text>
        </TouchableOpacity>
        <SpaceH />
        <View>
          <Text style={{color: "#fff", textAlign: 'center', fontSize: 11}}>Versão: {version} ({build})</Text>
        </View>
      </View>
    </View>
  );
});

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 20,
  },
  containerLogin: {
    backgroundColor: Theme.foreground,
    borderRadius: 10,
    padding: 40,
  },
  title: {
    fontSize: 18,
    fontWeight: 'bold',
    marginBottom: 30,
    color: '#fff',
  },
  inputContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
    marginBottom: 20,
    backgroundColor: Theme.background,
    borderRadius: 5,
    paddingHorizontal: 10,
    paddingVertical: 8,
  },
  input: {
    minWidth: 140,
    padding: 8,
    borderRadius: 8,
    borderColor: '#000',
    borderWidth: 1,
    borderStyle: 'solid',
    flex: 1,
    fontSize: 16,
    color: '#000',
  },
  button: {
    width: '100%',
    backgroundColor: '#fff',
    padding: 15,
    borderRadius: 5,
    alignItems: 'center',
    marginTop: 20,
  },
  buttonText: {
    color: Theme.foreground,
    fontSize: 16,
    fontWeight: 'bold',
  },
});

export default Auth;
